import * as React from 'react';
import styles from './PatientInfoBanner.module.esm.js';
import classNames from 'classnames';
import { IconProfile } from '@invitae/iconograph-react';

var PatientInfoBanner = function (_a) {
    var patientInformation = _a.patientInformation;
    if (!patientInformation.firstName || !patientInformation.lastName || !patientInformation.dob)
        return null;
    var firstName = patientInformation.firstName, lastName = patientInformation.lastName, dob = patientInformation.dob;
    return (React.createElement("div", { className: classNames(styles.bannerWrapper) },
        React.createElement("div", { className: styles.contentAndIconWrapper },
            React.createElement(IconProfile, { circle: "no", color: "none", size: "small" }),
            React.createElement("div", { className: styles.contentWrapper }, "".concat(firstName, " ").concat(lastName, ", DOB: ").concat(dob)))));
};

export { PatientInfoBanner };
//# sourceMappingURL=PatientInfoBanner.esm.js.map
